module.exports = __webpack_public_path__ + "media/images/applepay-629554111d0b2b2719470b46ae15074e.png";